import { ApkInfoModel } from '../../shared/models/apk-info.model';

export const checkIsApkInfoNonEmpty = (apkInfo: ApkInfoModel) => {
  return Object.values(apkInfo).every(value => {
    if (value == null) {
      return false;
    }

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    if (typeof value === 'string' || typeof value === 'number') {
      return value.toString().trim().length > 0;
    }

    return false;
  });
};
